<template>
  <div id="footer" class="">
    <div class="footer_top flex_sw">
      <div class="footer_bottom_l">
        <div class="footer_bottom_l_add">
          学校地址：{{ footinfo.contact_addr }}
        </div>
        <div class="footer_bottom_l_add">热线电话：{{ footinfo.contact_phone }}</div>
        <div class="footer_bottom_l_add">联系邮箱：{{ footinfo.contact_email }}</div>
        <div class="footer_bottom_l_list">
          <div class="footer_bottom_l_item" @click="handleTo('/aboutContent')">关于长理电力</div>
          <div class="footer_bottom_l_item" @click="handleTo('/recordedLessons')">录播课</div>
          <div class="footer_bottom_l_item" @click="handleTo('/questionBank')">题库</div>
          <div class="footer_bottom_l_item" @click="handleTo('/exam')">真题模考</div>
        </div>
      </div>
      <div class="footer_bottom_r">
        <div class="footer_bottom_r_item">
          <img :src="urls + footinfo.gongzhonghao" alt="" />
          <div>微信公众号</div>
        </div>
        <div class="footer_bottom_r_item">
          <img :src="urls + footinfo.wechat" alt="" />
          <div>微信号</div>
        </div>
      </div>
    </div>
    <div class="footer_bottom flex_center">
      <a href="https://beian.miit.gov.cn/">备案号：赣ICP备2025071322号</a>
      <div>版权所有：江西长理教育软件有限公司</div>
      <a href="http://jx.dinfen.com/">技术支持：鼎峰互动</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: this.imgurl,
      footinfo: {}
    };
  },
  mounted() {
    this.indexGetfooter()
  },
  methods: {
    async indexGetfooter() {
      let res = await this.$api.indexGetfooter()
      if (res.code == 1) {
        this.footinfo = res.data
      }
    },
    handleTo(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scope>
#footer {
  background-color: #fff;

  .footer_top {
    padding: 0.307rem 0.781rem 0.297rem;
    align-items: flex-start;

    .footer_bottom_l {
      .footer_bottom_l_add {
        font-size: 0.083rem;
        color: #333;
        margin-bottom: 0.057rem;
      }

      .footer_bottom_l_list {
        margin-top: 0.484rem;
        display: flex;

        .footer_bottom_l_item {
          font-size: 0.083rem;
          color: #333;
          margin-right: 0.292rem;
          cursor: pointer;
        }
      }
    }

    .footer_bottom_r {
      display: flex;

      .footer_bottom_r_item {
        margin-right: 0.052rem;
        font-size: 0.073rem;
        text-align: center;

        img {
          width: 0.625rem;
          height: 0.625rem;
          background-color: #0d4987;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .footer_bottom {
    height: 0.417rem;
    background-color: #0d4987;
    font-size: 0.083rem;
    color: #fff;

    a {
      font-size: 0.083rem;
      color: #fff;

      &:hover {
        text-decoration: underline;
      }
    }

    div,
    a {
      margin-right: 10px;
    }
  }
}

@media (max-width: 860px) {
  #footer {
    .footer_top {
      padding: 20px 20px;
      display: block;

      .footer_bottom_l {
        .footer_bottom_l_add {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .footer_bottom_l_list {
          margin-top: 0;
          display: flex;

          //   justify-content: center;
          .footer_bottom_l_item {
            font-size: 14px;
            color: #333;
            margin-right: 13px;
            cursor: pointer;
          }
        }
      }

      .footer_bottom_r {
        display: flex;
        justify-content: center;
        margin-top: 14px;

        .footer_bottom_r_item {
          margin-right: 10px;
          font-size: 14px;
          text-align: center;

          img {
            width: 100px;
            height: 100px;
            background-color: #0d4987;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .footer_bottom {
      // height: 0.417rem;
      height: auto;
      background-color: #0d4987;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 0;

      div,
      a {
        font-size: 16px;
        margin-right: 0;
      }
    }
  }
}
</style>